import { ExpandMoreOutlined } from '@mui/icons-material';
import { ReactElement } from 'react';

/**
 * The arrow on a row that opens something underneath it.
 *
 * It points where the content will go: right while closed, down while open —
 * the same way PaloFormSection and every file tree do it. The four trees in
 * this app each did the opposite, with their own copy of the rotation: an
 * upward arrow on a closed row, pointing away from what the click reveals.
 *
 * The dock at the foot of the screen keeps its own arrow, and rightly so: what
 * it opens appears above it, so there the closed state points up.
 */
export const PaloDisclosureArrow = ({ open }: { open: boolean }): ReactElement => (
    <ExpandMoreOutlined
        sx={{
            fontSize: 16,
            color: 'text.secondary',
            transition: 'transform .15s',
            transform: open ? 'none' : 'rotate(-90deg)',
        }}
    />
);
